import React from 'react';
import RealisationsHero from '../components/realisations/RealisationsHero/RealisationsHero';
import Button from '../components/common/Button/Button';
import styles from './QuiSommesNous.module.css';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, A11y } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

function QuiSommesNous() {
  return (
    <>
      <RealisationsHero
        title="Qui sommes-nous ?"
        subtitle="Artisans passionnés, unis par l'amour du bois et l'excellence coopérative."
        backgroundImage="/images/ossaturebois4.jpg" // Make sure this image exists
      >
        <Button to="/notre-cooperative" variant="primary">Découvrez notre modèle coopératif</Button>
      </RealisationsHero>
      <section className="section">
        <div className="container">
          <div className={styles.introSection}>
            <div className={styles.introContent}>
              <div className={styles.introText}>
                <span className={styles.eyebrow}>Notre Histoire</span>
                <h2 className={styles.title}>Depuis 2011, l'exigence d'une équipe passionnée</h2>
                <div className={styles.divider}></div>
                <p className={styles.description}>
                  Créée en 2011 sous l'impulsion de <strong>Vincent Quinard</strong>, Président Directeur Général issu d'une solide formation aux <strong>Compagnons du Devoir</strong> et spécialisé dans la construction bois, Maison Quinard est bien plus qu'une simple entreprise : c'est une histoire de passion et de transmission.
                </p>
                <div className={styles.highlightNotice}>
                  <p>Nous sommes une équipe d'artisans profondément attachés à la noblesse du matériau bois et au travail fait dans les règles de l'art.</p>
                </div>
              </div>
              <div className={styles.introImageWrapper}>
                <div className={styles.imageCard}>
                  <img src="/images/paysage.png" alt="Vincent Quinard - PDG" className={styles.mainImage} />
                  <div className={styles.experienceBadge}>
                    <span className={styles.badgeLabel}>2011</span>
                    <span className={styles.badgeText}>Création</span>
                  </div>
                </div>
                <div className={styles.imageDecoration}></div>
              </div>
            </div>
          </div>

          <div className={styles.teamSection} style={{ marginBottom: 'var(--spacing-xxl)' }}>
            <div className={styles.teamContent} style={{ gridTemplateColumns: '0.8fr 1.2fr' }}>
              <div className={styles.teamImageWrapper}>
                <div className={styles.imageCard}>
                  <img src="/images/plan.jpg" alt="Bureau d'étude Maison Quinard" className={styles.mainImage} />
                  <div className={styles.teamBadge} style={{ left: 'auto', right: '20px' }}>
                    <span className={styles.badgeLabel}>3D</span>
                    <span className={styles.badgeText}>Conception</span>
                  </div>
                </div>
                <div className={styles.imageDecoration}></div>
              </div>
              <div className={styles.teamText} style={{ textAlign: 'left' }}>
                <span className={styles.eyebrow}>Bureau d'Étude & Conception</span>
                <h2 className={styles.title}>Le sur-mesure absolu, adapté à tout projet</h2>
                <div className={styles.divider} style={{ margin: '0 0 var(--spacing-lg) 0' }}></div>
                <p className={styles.description}>
                  Parce que chaque famille et chaque terrain sont uniques, nous n'imposons aucun catalogue figé. Notre <strong>bureau d'étude technique intégré</strong> travaille de concert avec nos artisans pour une flexibilité totale et une conception entièrement personnalisée.
                </p>
                <p className={styles.description}>
                  De l'architecture ultra-contemporaine à l'extension traditionnelle, nous nous adaptons à une infinité de projets. Modélisation 3D, plans d'exécution et calculs de structures gérés en interne garantissent que chaque idée prend vie avec rigueur et précision.
                </p>
              </div>
            </div>
          </div>

          <div className={styles.philosophySection} style={{ marginBottom: 'var(--spacing-xxl)' }}>
            <div className={styles.philosophyContent} style={{ gridTemplateColumns: '1.2fr 0.8fr' }}>
              <div className={styles.philosophyText} style={{ paddingRight: 'var(--spacing-xl)' }}>
                <span className={styles.eyebrow}>Notre Force</span>
                <h2 className={styles.title}>L'Atelier de Menuiserie : De la fabrication à la pose</h2>
                <div className={styles.divider}></div>
                <p className={styles.description}>
                  Contrairement à de nombreuses entreprises qui se contentent d'assembler des éléments achetés à l'extérieur, Maison Quinard possède son propre <strong>atelier de menuiserie et de taille de charpente</strong>.
                </p>
                <p className={styles.textHighlight}>
                  Nous ne sommes pas que des poseurs, nous sommes des fabricants.
                </p>
                <p className={styles.description}>
                  Murs à ossature bois, chevêtres, structures complexes de charpente : nous concevons et fabriquons tous les éléments structurels de nos chantiers dans notre atelier. Cette maîtrise complète de la chaîne de production nous permet de garantir une finition parfaite, de respecter scrupuleusement vos délais et d'assurer une qualité sans aucun compromis.
                </p>
              </div>
              <div className={styles.philosophyImageWrapper}>
                <div className={styles.imageCard}>
                  <img src="/images/atelier.jpg" alt="Atelier de fabrication bois" className={styles.mainImage} />
                </div>
                <div className={styles.imageDecoration}></div>
              </div>
            </div>
          </div>

          <div className={styles.teamSection} style={{ marginBottom: 'var(--spacing-xxl)' }}>
            <div className={styles.teamContent} style={{ gridTemplateColumns: '0.9fr 1.1fr' }}>
              <div className={styles.teamImageWrapper}>
                <div className={styles.imageCard}>
                  <img src="/images/ossaturebois4.jpg" alt="Maison ossature bois performante" className={styles.mainImage} />
                  <div className={styles.teamBadge} style={{ left: 'auto', right: '20px', background: 'var(--color-primary)', color: 'var(--color-white-pure)' }}>
                    <span className={styles.badgeLabel}>A+</span>
                    <span className={styles.badgeText}>Énergie</span>
                  </div>
                </div>
                <div className={styles.imageDecoration}></div>
              </div>
              <div className={styles.teamText} style={{ textAlign: 'left' }}>
                <span className={styles.eyebrow}>Engagement & Avenir</span>
                <h2 className={styles.title}>Une conviction forte pour la performance énergétique</h2>
                <div className={styles.divider} style={{ margin: '0 0 var(--spacing-lg) 0' }}></div>
                <p className={styles.description}>
                  Si nous avons fait le choix de nous spécialiser dans le bois, c'est avant tout par conviction écologique. Notre véritable envie est de développer ce matériau extraordinaire pour répondre très concrètement aux défis environnementaux et d'isolation de demain.
                </p>
                <p className={styles.description}>
                  Très engagés dans cette démarche d'éco-construction performante (dépassant largement les normes RE2020), nous exploitons le plein potentiel de l'ossature bois : suppression drastique des ponts thermiques et isolation naturelle exceptionnelle. C'est l'assurance pour vous de vivre dans un habitat sain, chaleureux, et incroyablement économe en énergie.
                </p>
              </div>
            </div>
          </div>

          <div className={styles.commitmentsSection}>
            <div className={styles.sectionHeader}>
              <span className={styles.eyebrow}>Nos Valeurs</span>
              <h2 className={styles.title}>Nos Engagements</h2>
              <div className={styles.divider}></div>
            </div>
            <Swiper
              modules={[Navigation, Pagination, A11y]}
              spaceBetween={30}
              slidesPerView={1}
              navigation
              pagination={{ clickable: true }}
              grabCursor={true}
              loop={true}
              breakpoints={{
                768: { slidesPerView: 2, spaceBetween: 20 },
                1024: { slidesPerView: 3, spaceBetween: 30 },
              }}
              className={styles.commitmentsCarousel}
            >
              <SwiperSlide>
                <div className={styles.commitmentCard}>
                  <div className={styles.cardHeader}>
                    <span className={styles.cardIcon}>💎</span>
                    <h4>Qualité et Précision</h4>
                  </div>
                  <p>Un travail d'excellence, réalisé dans les règles de l'art avec une attention méticuleuse à chaque détail.</p>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className={styles.commitmentCard}>
                  <div className={styles.cardHeader}>
                    <span className={styles.cardIcon}>🌿</span>
                    <h4>Durabilité et Écologie</h4>
                  </div>
                  <p>Nous utilisons des matériaux responsables et des techniques respectueuses de l'environnement pour un habitat sain.</p>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className={styles.commitmentCard}>
                  <div className={styles.cardHeader}>
                    <span className={styles.cardIcon}>📍</span>
                    <h4>Engagement Local</h4>
                  </div>
                  <p>Ancrés à Arnouville-lès-Mantes, nous favorisons les circuits courts et les partenaires de notre territoire.</p>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className={styles.commitmentCard}>
                  <div className={styles.cardHeader}>
                    <span className={styles.cardIcon}>🤝</span>
                    <h4>Relation Client</h4>
                  </div>
                  <p>Une écoute active et un accompagnement personnalisé vous sont garantis pour un projet en toute confiance.</p>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className={styles.commitmentCard}>
                  <div className={styles.cardHeader}>
                    <span className={styles.cardIcon}>🚀</span>
                    <h4>Innovation Continue</h4>
                  </div>
                  <p>Une veille constante sur les nouvelles techniques pour des constructions toujours plus innovantes et performantes.</p>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>

          <div className={styles.teamSection}>
            <div className={styles.teamContent}>
              <div className={styles.teamText}>
                <span className={styles.eyebrow}>Le Savoir-Faire Humain</span>
                <h2 className={styles.title}>Notre Équipe</h2>
                <div className={styles.divider}></div>
                <p className={styles.description}>
                  Nos charpentiers, menuisiers et chefs de projet sont des experts dévoués, animés par une passion commune pour l'artisanat du bois. Chaque membre de l'équipe s'investit pleinement pour garantir la réussite de votre projet.
                </p>
                <p className={styles.description}>
                  Nous travaillons main dans la main, du premier croquis à la dernière finition, avec un seul objectif : votre entière satisfaction. Notre savoir-faire collectif nous permet de relever tous les défis techniques.
                </p>
              </div>
              <div className={styles.teamImageWrapper}>
                <div className={styles.imageCard}>
                  <img src="/images/maison3.jpg" alt="L'équipe de Maison Quinard" className={styles.mainImage} />
                  <div className={styles.teamBadge}>
                    <span className={styles.badgeLabel}>SCOP</span>
                    <span className={styles.badgeText}>100% Humain</span>
                  </div>
                </div>
                <div className={styles.imageDecoration}></div>
              </div>
            </div>
          </div>

          <div className={styles.recruitmentTeaser}>
            <div className={styles.teaserContent}>
              <div className={styles.teaserText}>
                <span className={styles.eyebrow}>Carrière</span>
                <h2>Rejoignez l'Aventure</h2>
                <div className={styles.divider}></div>
                <p>
                  Plus qu'un métier, une aventure humaine au sein d'une coopérative d'exception.
                  Nous recherchons des charpentiers et menuisiers passionnés pour construire ensemble l'habitat de demain.
                </p>
                <Button to="/recrutement" variant="primary" size="large">Voir nos opportunités</Button>
              </div>
              <div className={styles.teaserImageWrapper}>
                <img src="/images/ossaturebois2.jpg" alt="Artisan au travail chez Maison Quinard" />
              </div>
            </div>
            <div className={styles.teaserDecoration}>🛠️</div>
          </div>

          <div className={styles.finalCTA}>
            <div className={styles.ctaCard}>
              <div className={styles.ctaContent}>
                <span className={styles.eyebrow}>Modèle de Travail</span>
                <h3 className={styles.ctaTitle}>Découvrez notre modèle coopératif</h3>
                <div className={styles.ctaDivider}></div>
                <p className={styles.ctaDescription}>Envie d'en savoir plus sur notre fonctionnement unique et nos valeurs d'entreprise ?</p>
                <div className={styles.ctaButtonWrapper}>
                  <Button to="/notre-cooperative" variant="primary" size="large">Notre coopérative</Button>
                </div>
              </div>
              <div className={styles.ctaDecoration}></div>
            </div>
          </div>

        </div>
      </section>
    </>
  );
}

export default QuiSommesNous;
